export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    levelModifier() {
      return `fee-waived-banner--${this.level}`;
    },
  },
};
